import { Controller, useFormContext } from 'react-hook-form'
import { RadioGroup, FormControlLabel, Radio } from '@mui/material'
import { CAMPAIGN_ERROR_MESSAGE } from '~/constants/campaign'
import { z } from 'zod'
import { PrTargetGender as PrTargetGenderEnum } from '~/generated/graphql'
import { ValidationErrorMessage } from '~/components/common/ValidationErrorMessage'

export const prTargetGenderSchemaFields = {
  prTargetGender: z
    .enum(
      [PrTargetGenderEnum.Female, PrTargetGenderEnum.Male, PrTargetGenderEnum.FemaleAndMale, PrTargetGenderEnum.None],
      {
        required_error: CAMPAIGN_ERROR_MESSAGE.REQUIRED,
      },
    )
    .refine((val) => val !== PrTargetGenderEnum.None, {
      message: CAMPAIGN_ERROR_MESSAGE.REQUIRED,
    }),
}
export const prTargetGenderSchema = z.object(prTargetGenderSchemaFields)

type GenderOptionProps = {
  id: PrTargetGenderEnum
  label: string
}[]

const genderOptions: GenderOptionProps = [
  { id: PrTargetGenderEnum.FemaleAndMale, label: 'どちらも' },
  { id: PrTargetGenderEnum.Male, label: '男性向け' },
  { id: PrTargetGenderEnum.Female, label: '女性向け' },
]

export const PrTargetGender = () => {
  const { control } = useFormContext<z.infer<typeof prTargetGenderSchema>>()
  return (
    <Controller
      name="prTargetGender"
      control={control}
      render={({ field: { ref, ...field }, fieldState: { error } }) => (
        <>
          <RadioGroup
            aria-label="prTargetGender"
            name="prTargetGender"
            value={field.value}
            onChange={(event) => field.onChange(event.target.value)}
          >
            {genderOptions.map((option, index) => (
              <FormControlLabel
                key={option.id}
                value={option.id}
                control={<Radio inputRef={index === 0 ? ref : undefined} />}
                label={option.label}
              />
            ))}
          </RadioGroup>
          <ValidationErrorMessage error={error?.message} />
        </>
      )}
    />
  )
}
